import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import React from "react";

import { Equipment } from "domain/entities/equipment";
import { EquipmentType } from "domain/entities/equipment-type";
import InputTextComponent from "presentation/components/Shared/InputTextComponent";

interface EquipmentBaseTabProps {
  selectedEquipment: Equipment;
  setSelectedEquipment: (equipment: Equipment) => void;
  filteredTypes: EquipmentType[];
  readOnlyBaseFields: boolean;
  showOnlyVehicles: boolean;
  hasVehicleType: boolean;
  tabContentStyle: React.CSSProperties;
  dropdownLabelStyle: React.CSSProperties;
  isAdmin?: boolean;
}

const EquipmentBaseTab: React.FC<EquipmentBaseTabProps> = ({
  selectedEquipment,
  setSelectedEquipment,
  filteredTypes,
  readOnlyBaseFields,
  showOnlyVehicles,
  hasVehicleType,
  tabContentStyle,
  dropdownLabelStyle,
  isAdmin = false,
}) => {
  return (
    <div style={tabContentStyle}>
      <div className="formgrid grid mt-3">
        <div className="field col-12 md:col-6 mb-4 mt-2">
          <span className="p-float-label">
            <Dropdown
              id="equipmentTypeId"
              options={filteredTypes}
              optionLabel="name"
              optionValue="id"
              value={selectedEquipment.equipmentTypeId}
              onChange={(e) =>
                setSelectedEquipment({
                  ...selectedEquipment,
                  equipmentTypeId: e.value,
                })
              }
              className="w-full"
              disabled={
                readOnlyBaseFields || (showOnlyVehicles && hasVehicleType)
              }
            />
            <label htmlFor="equipmentTypeId" style={dropdownLabelStyle}>
              Tipo de Equipamento
            </label>
          </span>
        </div>

        <div className="field col-12 md:col-6 mb-4 mt-2">
          <InputTextComponent
            fieldName="brand"
            label="Marca"
            currentObject={selectedEquipment}
            getValue={selectedEquipment.brand}
            setValue={setSelectedEquipment}
            isDisable={readOnlyBaseFields}
          />
        </div>

        <div className="field col-12 md:col-6 mb-4 mt-2">
          <InputTextComponent
            fieldName="model"
            label="Modelo"
            currentObject={selectedEquipment}
            getValue={selectedEquipment.model}
            setValue={setSelectedEquipment}
            isDisable={readOnlyBaseFields}
          />
        </div>

        <div className="field col-12 md:col-6 mb-4 mt-2">
          <InputTextComponent
            fieldName="serialOrCarRegistration"
            label="Número de Série / Matrícula"
            currentObject={selectedEquipment}
            getValue={selectedEquipment.serialOrCarRegistration}
            setValue={setSelectedEquipment}
            isDisable={readOnlyBaseFields}
          />
        </div>

        {isAdmin && (
          <>
            <div className="col-12 mt-4 pt-4 font-bold border-bottom-1 surface-border pb-2 mb-3">
              Informação de Compra e Garantia (Opcional)
            </div>

            <div className="field col-12 md:col-6 mb-4 mt-3">
              <InputTextComponent
                fieldName="supplier"
                label="Fornecedor"
                currentObject={selectedEquipment}
                getValue={selectedEquipment.supplier || ""}
                setValue={setSelectedEquipment}
                isDisable={readOnlyBaseFields}
              />
            </div>

            <div className="field col-12 md:col-6 mb-4 mt-3">
              <InputTextComponent
                fieldName="invoice"
                label="Fatura"
                currentObject={selectedEquipment}
                getValue={selectedEquipment.invoice || ""}
                setValue={setSelectedEquipment}
                isDisable={readOnlyBaseFields}
              />
            </div>

            <div className="field col-12 md:col-6 mb-4 mt-2">
              <span className="p-float-label">
                <Calendar
                  id="purchaseDate"
                  value={
                    selectedEquipment.purchaseDate
                      ? new Date(selectedEquipment.purchaseDate)
                      : null
                  }
                  onChange={(e) =>
                    setSelectedEquipment({
                      ...selectedEquipment,
                      purchaseDate: e.value || null,
                    })
                  }
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  showIcon
                  disabled={readOnlyBaseFields}
                />
                <label htmlFor="purchaseDate">Data de Compra</label>
              </span>
            </div>

            <div className="field col-12 md:col-6 mb-4 mt-2">
              <span className="p-float-label">
                <InputText
                  id="warrantyMonths"
                  type="number"
                  value={
                    selectedEquipment.warrantyMonths
                      ? String(selectedEquipment.warrantyMonths)
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedEquipment({
                      ...selectedEquipment,
                      warrantyMonths: Number(e.target.value) || null,
                    })
                  }
                  className="w-full"
                  disabled={readOnlyBaseFields}
                />
                <label htmlFor="warrantyMonths">Garantia (Meses)</label>
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EquipmentBaseTab;
